'use strict';

/* Globals */
var version = 'v1.1.0';
var g,
    map,
    zoom,
    rect,
    path,
    width,
    height,
    svgMap,
    projection,
    mapIsHidden,
    mapIsZoomed,
    activeLocation;

/* Load D3.js World Map */
function loadD3Map() {
    // Set projection
    projection = d3.geo.naturalEarth()
        .scale(width/6)
        .translate([width / 2, height / 2])
        .rotate([-10, 0])
        .precision(0.1);
    // Set zoom interaction
    zoom = d3.behavior.zoom()
        .translate([0, 0])
        .scale(1)
        .scaleExtent([1, 8])
        .on('zoom', zoomed);
    path = d3.geo.path()
        .projection(projection);
    // Create map grid
    var graticule = d3.geo.graticule();
    svgMap = d3.select('#world').append('svg')
        .attr('width', width)
        .attr('height', height)
        .on('click', stopevents, true);
    g = svgMap.append('g');
    svgMap
        .call(zoom)
        .call(zoom.event);
    g.append('defs').append('path')
        .datum({type: 'Sphere'})
        .attr('id', 'sphere')
        .attr('d', path);
    g.append('use')
        .attr('class', 'stroke')
        .attr('xlink:href', '#sphere');
    g.append('use')
        .attr('class', 'fill')
        .attr('xlink:href', '#sphere');
    g.append('path')
        .datum(graticule)
        .attr('class', 'graticule')
        .attr('d', path);
    // Create area for zoom reset
    rect = g.append('rect')
        .attr('class', 'background')
        .attr('width', width)
        .attr('height', height)
        .on('click', resetZoom);
    // Load World data (/50m.json = 747KB vs. /110m.json = 102KB)
    d3.json('https://cdn.jsdelivr.net/npm/world-atlas@1/world/110m.json', function(error, world) {
        g.insert('path', '.graticule')
            .datum(topojson.feature(world, world.objects.land))
            .attr('class', 'land')
            .attr('d', path);
        g.insert('path', '.graticule')
            .datum(topojson.mesh(world, world.objects.countries, function(a, b) { return a !== b; }))
            .attr('class', 'boundary')
            .attr('d', path);
        var request = new XMLHttpRequest();
        request.open('GET', 'https://raw.githubusercontent.com/bacinger/f1-circuits/master/f1-locations.json', true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var circuitLocations = JSON.parse(request.responseText);
                loadCircuitLocations(circuitLocations);
            }
        };
        request.send();
    });
}

/* Load Mapbox World Map */
function loadMapbox() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYmFjaW5nZXIiLCJhIjoiY2tmYXhlYzA4MTBqaTJzcHAzc3ZveXozdCJ9.vgZXOXA1Pe475giKIst6xQ';
    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/satellite-v9',
        center: [0, 25],
        zoom: 1
    });
    map.addControl(new mapboxgl.NavigationControl());
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();
    map.on('load', function() {
        loadD3Map();
        /* TopoJSON -> GeoJSON
        d3.json('https://raw.githubusercontent.com/bacinger/f1-circuits/master/f1-circuits.json', function(error, data) {
            var f1_circuits = topojson.feature(data, data.objects.f1_circuits); 
            map.addSource('f1_circuits', {
                'type': 'geojson',
                'data': f1_circuits
            });
            ...
        }); */
        map.addSource('f1_circuits', {
            'type': 'geojson',
            'data': 'https://raw.githubusercontent.com/bacinger/f1-circuits/master/f1-circuits.geojson'
        });
        map.addLayer({
            'id': 'circuits',
            'type': 'line',
            'source': 'f1_circuits',
            'paint': {
                'line-color': '#ccff00',
                'line-width': 6,
                'line-opacity': 0.8
                }
        });
    });
    mapIsHidden = true;
    mapIsZoomed = false;
    
}

/* Load Circuit Locations to D3 */
function loadCircuitLocations(data) {
    g.selectAll('circle')
        .remove();
    setTimeout(function() {
        g.selectAll('circle')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', function(d) {
                return projection([d.lon, d.lat])[0];
            })
            .attr('cy', function(d) {
                return projection([d.lon, d.lat])[1];
            })
            .attr('r', 4)
            .attr('class', 'locations')
            .on('click', zoomToClick)
            .on('mouseover', function(d) {
                showLocation(d, this);
            })
            .on('mouseout', function(d) {
                hideLocation(d, this);
            });
    }, 50);
    var selectData = [{ lat: "25", lon: "0", zoom: "1", location: "", name: "Select a circuit" }].concat(data);
    var menu = d3.select("#menu")
        .on("change", change);
    menu.selectAll("option")
        .data(selectData)
        .enter().append("option")
            .text(function(d) { return d.location + ' - ' + d.name; })
            .attr("value", function (d) { return JSON.stringify(d); });
}
function change() {
    var d = JSON.parse(this.value);
    map.flyTo({
        center: [d.lon, d.lat],
        zoom: d.zoom,
        bearing: 0
    });
}

/* Map Events */
function zoomed() {
    g.attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
}
function stopevents() {
    if (d3.event.defaultPrevented) { d3.event.stopPropagation(); }
}
function resetZoom() {
    g.selectAll('.locations')
        .classed('active', activeLocation && false);
    g.selectAll('circle')
        .transition()
        .duration(200)
        .attr('r', 4)
        .style('fill', '#ff3f00');
    activeLocation = undefined;
    svgMap.transition()
        .duration(800)
        .call(zoom.translate([0, 0]).scale(1).event);
    document.getElementById('location').style.display = 'none';
    mapIsZoomed = false;
}
function showLocation(d, c) {
    if (d && activeLocation !== d) {
        var pointsize = 8;
        if (mapIsZoomed) pointsize = 4;
        d3.select(c)
            .transition()
            .duration(400)
            .attr('r', pointsize)
            .style('fill', '#0969a2');
        g.selectAll('.locations')
            .classed('active', activeLocation && false);
        activeLocation = undefined;
        var el = document.getElementById('location');
        el.innerHTML = d.location + ' - ' + d.name;
        el.style.display = 'inline';
    }
}
function hideLocation(d, c) {
    if (!activeLocation) {
        var pointsize = 4;
        if (mapIsZoomed) pointsize = 2;
        d3.select(c)
            .transition()
            .duration(200)
            .attr('r', pointsize)
            .style('fill', '#ff3f00');
        document.getElementById('location').style.display = 'none';
    }
}
function zoomToClick(d) {
    var x, y, scale;
    if (d && activeLocation !== d) {
        x = this.cx.baseVal.value;
        y = this.cy.baseVal.value;
        scale = 8;
        g.selectAll('circle')
            .transition()
            .duration(200)
            .attr('r', 2)
            .style('fill', '#ff3f00');
        showLocation(d, this)
        activeLocation = d;
        mapIsZoomed = true;
    } else {
        return resetZoom();
    }
    var translate = [width / 2 - scale * x, height / 2 - scale * y];
    g.selectAll('.locations')
        .classed('active', activeLocation && function(d) { return d === activeLocation; });
    svgMap.transition()
        .duration(800)
        .call(zoom.translate(translate).scale(scale).event);
    map.flyTo({
        center: [d.lon, d.lat],
        zoom: d.zoom,
        bearing: 0
    });
}
d3.select("#switch").on("click",function() {
    if (mapIsHidden) {
        d3.select('#world').classed("hidden", false);
        d3.select("#menu").classed("hidden", true);
        setSize();
        mapIsHidden = false;
    }
    else {
        d3.select('#world').classed("hidden", true);
        d3.select("#menu").classed("hidden", false);
        document.getElementById('world').style.width = 0;
        document.getElementById('world').style.height = 0;
        document.getElementById('location').style.display = 'none';
        mapIsHidden = true;
    }
});

/* Set Window Sizes */
function setSize() {
    var magic = 600;
    var mobile = 641;
    var ww = window.innerWidth;
    var wh = window.innerHeight;
    document.getElementById('map').style.width = ww + 'px';
    document.getElementById('map').style.height = wh + 'px';
    width = magic;
    if (ww < 400) { width = ww; }
    height = width / 2;
    document.getElementById('world').style.width = width + 'px';
    document.getElementById('world').style.height = height + 'px';
    document.getElementById('location').style.bottom = height + 'px';
    if (ww < mobile) {
        document.getElementById('world').style.bottom = '35px';
        document.getElementById('location').style.bottom = height + 35 + 'px';
    }
}

/* Initial Loading */
document.addEventListener('DOMContentLoaded', function(e) {
    console.log(version);
    setSize();
    loadMapbox();
});